import React, { useState, useEffect } from "react";
import NhanVayApi from "service/nhanVayApi";
import { getDate } from "utils/formatDate";

export const LichSuGiaHan = ({ nhanvayId }) => {
  const dataInit = {
    List: [],
  };
  const [dataLichSuGiaHan, UpdateDataLichSuGiaHan] = useState(dataInit);
  const DanhSachLichSuGiaHan = (page) => {
    NhanVayApi.getLichSuGiaHanNhanVay(nhanvayId).then((response) => {
      UpdateDataLichSuGiaHan({
        ...dataLichSuGiaHan,
        List: response.data.List,
      });
    });
  };

  useEffect(() => {
    DanhSachLichSuGiaHan();
  }, []);

  const listItem = () => {
    return (
      dataLichSuGiaHan.List != null &&
      dataLichSuGiaHan.List.map((item, index) => {
        return (
          <>
            <tr className="">
              <td>{index + 1}</td>
              <td className="text-left">{getDate(item.ThoiGian)}</td>
              <td className="text-right">{item.SoLan}</td>
              <td className="text-left">{item.GhiChu}</td>
            </tr>
          </>
        );
      })
    );
  };

  return (
    <div className="Left808x200 Table-main-morman table-noboder-new">
      <div className="table-responsive table-new1">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th className="w-5">STT</th>
              <th className="w-15">Ngày gia hạn</th>
              <th className="w-20 text-right">Số lần gia hạn thêm</th>
              <th className="text-left">Lý do gia hạn</th>
            </tr>
          </thead>
          <tbody>{listItem()}</tbody>
        </table>
      </div>
    </div>
  );
};
